import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useChampionship } from "@/context/ChampionshipContext";
import { CountryBlock } from "@/components/PlayerCard";

export default function TeamsPage() {
  const { current } = useChampionship() || {};
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!current?.id) return;
    setLoading(true);
    api.get(`/championships/${current.id}/teams`).then((r) => setTeams(r.data || [])).finally(() => setLoading(false));
  }, [current?.id]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="teams-page">
      <div className="border-b border-border pb-10 mb-12">
        <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">
          {current?.year} — {current?.location}
        </div>
        <h1 className="font-display text-5xl md:text-7xl font-extrabold tracking-tighter mt-3">Teams</h1>
        <p className="mt-4 text-muted-foreground max-w-2xl">
          Players entered by their national federations. Rosters are confirmed by the organising committee.
        </p>
      </div>

      <Legend />

      <TeamsList loading={loading} teams={teams} />
    </div>
  );
}

function TeamsList({ loading, teams }) {
  if (loading) {
    return <div className="text-muted-foreground">Loading teams…</div>;
  }
  if (teams.length === 0) {
    return (
      <div className="text-muted-foreground" data-testid="teams-empty">
        No teams have been registered yet. National federations will appear here as captains submit their rosters.
      </div>
    );
  }
  return (
    <div className="mt-12">
      {teams.map((t) => (
        <CountryBlock key={t.country_code} team={t} />
      ))}
    </div>
  );
}

function Legend() {
  const items = [
    { color: "bg-pink-600", label: "Female", letter: "F" },
    { color: "bg-amber-500", label: "Youth (U18)", letter: "Y" },
    { color: "bg-yellow-400 text-black", label: "Star player", letter: "★" },
    { color: "bg-primary", label: "Past champion", letter: "T" },
  ];
  return (
    <div className="flex flex-wrap items-center gap-6 mb-8 text-xs text-muted-foreground" data-testid="legend">
      {items.map((i) => (
        <div key={i.label} className="flex items-center gap-2">
          <span className={`inline-flex h-5 w-5 items-center justify-center rounded-full ${i.color} text-white font-bold text-[10px]`}>
            {i.letter}
          </span>
          {i.label}
        </div>
      ))}
    </div>
  );
}
